export function resolveSvrInvoicePdfPath(input: {
  invoiceToken?: string | null;
  legacyInvoiceUrl?: string | null;
}): string | null {
  const token = String(input.invoiceToken ?? "").trim();
  if (token) {
    return `/api/svr-invoices/${encodeURIComponent(token)}/invoice.pdf`;
  }

  const legacyUrl = String(input.legacyInvoiceUrl ?? "").trim();
  return legacyUrl || null;
}
